import React from 'react'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import './index.css'

type Brand = { brand: string; version: string }

type NavigatorUAData = {
  brands?: Brand[]
  getHighEntropyValues?: (hints: string[]) => Promise<{ fullVersionList?: Brand[] }>
}

const COCCOC_BRAND = /coc_?coc|cốc\s*cốc/i
const BLOCKED_HTML = `
  <div style="font-family:system-ui,sans-serif;max-width:36rem;margin:4rem auto;padding:0 1.25rem;line-height:1.5;color:#1a1a1a">
    <h1 style="font-size:1.35rem;margin-bottom:.75rem">Trình duyệt không được hỗ trợ</h1>
    <p style="margin:0;color:#444">Trình duyệt Cốc Cốc không được hỗ trợ. Vui lòng dùng Chrome, Edge hoặc Firefox.</p>
  </div>
`

function brandsLookLikeCocCoc(brands: Brand[] | undefined | null): boolean {
  return (brands ?? []).some((b) => COCCOC_BRAND.test(b.brand || ''))
}

async function isCocCocBrowser(): Promise<boolean> {
  const ua = navigator.userAgent || ''
  if (/coc_coc_browser|coccoc|cốc\s*cốc/i.test(ua)) return true

  const uaData = (navigator as Navigator & { userAgentData?: NavigatorUAData }).userAgentData
  if (!uaData) return false

  if (brandsLookLikeCocCoc(uaData.brands)) return true

  if (typeof uaData.getHighEntropyValues === 'function') {
    try {
      const high = await uaData.getHighEntropyValues(['fullVersionList'])
      if (brandsLookLikeCocCoc(high.fullVersionList)) return true
    } catch {
      // Permission / unsupported — fall through
    }
  }

  return false
}

function renderApp() {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>,
  )
}

void isCocCocBrowser().then((blocked) => {
  if (blocked) {
    document.body.innerHTML = BLOCKED_HTML
    return
  }
  renderApp()
})
